/* shah */
import React from 'react'

const BlackCurserIcon = () => {
    return (
        <svg id="SmallBoxSVG-blackBigCurser" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M1030 5098 c-18 -13 -43 -36 -54 -51 l-21 -28 -3 -2012 c-3 -2242 -8
  -2068 66 -2125 30 -23 45 -27 98 -27 53 0 68 4 102 30 22 17 212 180 422 363
  l380 333 21 -48 c11 -27 158 -370 326 -763 232 -545 312 -722 334 -743 52 -48
  74 -43 462 123 384 164 407 178 407 247 0 26 -92 252 -315 774 -173 405 -315
  739 -315 743 0 3 248 6 551 6 614 0 597 -2 645 69 28 42 33 125 10 169 -18 33
  -2922 2935 -2953 2951 -39 20 -126 14 -163 -11z"/>
            </g>
        </svg>
    )
}

export default BlackCurserIcon